module.exports = __webpack_public_path__ + "static/img/gpt55.84c7c214.png";